import React from 'react';
import {NodeProps} from 'reactflow';

import {RouterNodeData} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';
import BenchlingNode from 'ui-library/reactflow/nodes/BenchlingNode/BenchlingNode';

export default function RouterNodeRenderer(props: NodeProps<RouterNodeData>): JSX.Element {
  return <BenchlingNode<never, RouterNodeData> {...props} />;
}
